import React, { useState } from 'react';

import { faPlugCircleXmark } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import Snackbar from 'shared/snackbar';
import confirm from 'components/confirm';
import { deleteRequest } from 'helpers/api';

interface Props {
  destroyPath: string;
  variant?: string;
  onDestroy: () => void;
}

export default function DisconnectNylasGrant({ destroyPath, variant = 'ghost', onDestroy }: Props) {
  const [destroying, setDestroying] = useState(false);
  const [showError, setShowError] = useState(false);

  async function destroy() {
    try {
      await confirm('Are you sure you want to disconnect this integration?', {
        buttonLabel: 'Disconnect',
        buttonStyle: 'danger',
        title: 'Disconnect Integration',
      });
    } catch (e) {
      return;
    }

    try {
      setDestroying(true);
      await deleteRequest(destroyPath);
    } catch (e) {
      setShowError(true);
      return;
    } finally {
      setDestroying(false);
    }

    onDestroy();
  }

  return <>
    <Button
      disabled={destroying}
      icon={faPlugCircleXmark}
      label="Disconnect"
      variant={variant}
      onClick={destroy}
    />

    <Snackbar
      show={showError}
      text="Something went wrong"
      variant="danger"
      onClose={() => setShowError(false)}
    />
  </>;
}
